var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSucces(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4650",
    "data-name": "Group 4650",
    transform: "translate(5442.655 6538.655)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_681",
    "data-name": "Ellipse 681",
    cx: 43,
    cy: 43,
    r: 43,
    transform: "translate(-5442.655 -6538.655)",
    fill: "#ddf9e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4713",
    "data-name": "Path 4713",
    d: "M30.9,2a28.9,28.9,0,1,0,28.9,28.9A28.907,28.907,0,0,0,30.9,2Z",
    transform: "translate(-5430.552 -6526.552)",
    fill: "#56b364"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-check",
    "data-name": "Icon awesome-check",
    d: "M10.014,26.131.432,16.549a1.474,1.474,0,0,1,0-2.085L2.516,12.38a1.474,1.474,0,0,1,2.085,0l6.455,6.455L24.882,5.009a1.474,1.474,0,0,1,2.085,0l2.085,2.085a1.474,1.474,0,0,1,0,2.085L12.1,26.131A1.474,1.474,0,0,1,10.014,26.131Z",
    transform: "translate(-5414.397 -6511.225)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSucces);
export default __webpack_public_path__ + "static/media/succes.61025501e72539dcf252377b2424e979.svg";
export { ForwardRef as ReactComponent };